export default __webpack_public_path__ + "static/1992-10-14_prototyping_ICMC.pdf";